import { render, staticRenderFns } from "./AnaliticalReferrals.vue?vue&type=template&id=29f41dc5&scoped=true&"
import script from "./AnaliticalReferrals.vue?vue&type=script&lang=js&"
export * from "./AnaliticalReferrals.vue?vue&type=script&lang=js&"
import style0 from "./AnaliticalReferrals.vue?vue&type=style&index=0&id=29f41dc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f41dc5",
  null
  
)

export default component.exports